import { useEffect, useState } from "react";
import { getUser } from "../services/user";
import { FLASHDOCS_USER_CACHE_KEY } from "../consts";
import { getAuthToken, getUserEmail } from "../services/auth";

export function useUser(noCache = false) {
  const [user, setUser] = useState<{
    email: string;
    organization_id: string;
  } | null>(null);
  const [loading, setLoading] = useState(true);

  async function asyncCall() {
    const maybeUser = sessionStorage.getItem(FLASHDOCS_USER_CACHE_KEY);
    const userEmail = getUserEmail();
    const authToken = getAuthToken();
    if (maybeUser && userEmail && authToken && !noCache) {
      try {
        let user = JSON.parse(maybeUser);
        setUser(user);
        setLoading(false);
      } catch (error) {
        // not a problem, just a cache miss
      }
    }
    setLoading(true);
    const user = await getUser();
    setUser(user);
    setLoading(false);
    if (user.organization_id !== "DEFAULT") {
      sessionStorage.setItem(FLASHDOCS_USER_CACHE_KEY, JSON.stringify(user));
    }
  }

  useEffect(() => {
    asyncCall();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return { user, loading, refetch: asyncCall };
}
